import { Callout, CalloutVariant, Typography } from 'ui';
import { CheckCircle, ErrorOutline, Info } from '@mui/icons-material';
import { FunctionComponent } from 'react';
import { Theme } from '@emotion/react';
import { alertBase, alertIcon } from 'ui/Alert/alertCssDefs';

export type AlertVariant = Exclude<CalloutVariant, 'subtle' | 'internal'>;

const AlertIcon: FunctionComponent<React.PropsWithChildren<{ variant: AlertVariant }>> = ({
  variant,
}) => {
  switch (variant) {
    case 'default':
      return <Info />;
    case 'positive':
      return <CheckCircle />;
    case 'negative':
      return <ErrorOutline />;
    case 'warning':
      return <ErrorOutline />;
    default:
      return <Info />;
  }
};

export type AlertProps = {
  variant: AlertVariant;
  title?: string;
  message?: string;
  className?: string;
};

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Alert: FunctionComponent<React.PropsWithChildren<AlertProps>> = ({
  variant,
  className,
  title,
  message,
  children,
  ...rest
}) => {
  return (
    <Callout
      variant={variant}
      className={className}
      css={(theme: Theme) => alertBase(theme, variant)}
      disableTypography={true}
      {...rest}
    >
      <div css={alertIcon}>
        <AlertIcon variant={variant} />
      </div>
      <div>
        <Typography
          variant={message ? 'body2Medium' : 'body2Regular'}
          mb={!message && !children ? 0 : 0.5}
        >
          {title}
        </Typography>
        {message && (
          <Typography variant="body2Regular" mb={!children ? 0 : 1.5}>
            {message}
          </Typography>
        )}
        {children}
      </div>
    </Callout>
  );
};

export default Alert;
